import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  RewardsState,
  RewardState,
  RewardsCatAndSubCatPreferenceState,
} from './rewards.state';

export const selectRewardsState =
  createFeatureSelector<RewardsState>('rewards');
export const selectRewardState = createFeatureSelector<RewardState>('reward');
export const selectRewardsCatAndSubCatPreferenceState =
  createFeatureSelector<RewardsCatAndSubCatPreferenceState>(
    'rewardsCatAndSubCatPreference',
  );

// Get Rewards Selector
export const selectRewards = createSelector(
  selectRewardsState,
  (state: RewardsState) => state.rewards || [],
);

export const selectRewardsLoading = createSelector(
  selectRewardsState,
  (state: RewardsState) => state.loading,
);

export const selectRewardsError = createSelector(
  selectRewardsState,
  (state: RewardsState) => state.error,
);

export const selectRewardsParams = createSelector(
  selectRewardsState,
  (state: RewardsState) => state?.params,
);

export const selectRewardsFiltersCount = createSelector(
  selectRewardsState,
  (state: RewardsState) => state?.filtersCount,
);

//Get Reward By ID Selector
export const selectReward = createSelector(
  selectRewardState,
  (state: RewardState) => state?.reward,
);

export const selectRewardLoading = createSelector(
  selectRewardState,
  (state: RewardState) => state?.loading,
);

export const selectRewardError = createSelector(
  selectRewardState,
  (state: RewardState) => state?.error,
);

//Get Reward Category Preference Selector
export const selectRewardsCatAndSubCatPreference = createSelector(
  selectRewardsCatAndSubCatPreferenceState,
  (state: RewardsCatAndSubCatPreferenceState) => state?.rewardCategories,
);

export const selectRewardsCatAndSubCatPreferenceLoading = createSelector(
  selectRewardsCatAndSubCatPreferenceState,
  (state: RewardsCatAndSubCatPreferenceState) => state?.loading,
);

export const selectRewardsCatAndSubCatPreferenceError = createSelector(
  selectRewardsCatAndSubCatPreferenceState,
  (state: RewardsCatAndSubCatPreferenceState) => state?.error,
);

export const selectRewardQtyState = createSelector(
  selectRewardsState,
  (state) => state.rewardQty,
);

export const selectRewardSpinner = createSelector(
  selectRewardsState,
  (state) => state.spinner,
);

export const selectRewardsCatAndSubCatPreferenceParams = createSelector(
  selectRewardsCatAndSubCatPreferenceState,
  (state: RewardsCatAndSubCatPreferenceState) => state?.params,
);
